import React, { FC } from "react";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import { Input, InputLabel, FormControl } from "@mui/material";
interface IInputText {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleBlur: any;
  errorsField: any;
  touched: any;
  value: any;
  autofocus?: any;
  readOnly?: any;
  disabled?: any;
  type?: string;
  onKeyDown?: any;
  tabindex ?:any
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, readOnly, disabled
}
 * @returns {*}
 */
const InputText: FC<IInputText> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  autofocus,
  readOnly,
  disabled,
  type,
  onKeyDown,
  tabindex
}) => {
  let inputProps = {};

  if (type && type == "number") {
    inputProps = {
      readOnly: Boolean(readOnly),
      disabled: Boolean(disabled),
      inputMode: "numeric",
      pattern: "[0-9]*.?[0-9]+",
    };
  } else {
    inputProps = {
      readOnly: Boolean(readOnly),
      disabled: Boolean(disabled),
    };
  }
  return (
    <>
   
      <TextField
        autoFocus={autofocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        defaultValue={value}
        value={value}
        onChange={handleChange}
        type={type ? type : "text"}
        error={errorsField && touched}
        label={label}
        helperText={errorsField && touched ? errorsField : ""}
        name={controlId}
        // readOnly={readOnly}
        disabled={disabled}
        inputProps={{ inputProps ,tabIndex: tabindex? tabindex :0}}
        onKeyDown={onKeyDown}
       // tabIndex={tabindex}
       
      />

      {/* <Form.Label className="mb-1 text-uppercase fs-11 fw-bold label-color ls-small">{label}</Form.Label> 
             <div className="position-relative">
                 {/* <Form.Control value={value} type="text" placeholder={placeholder} onBlur={handleBlur} onChange={handleChange} isInvalid={!!errorsField && touched} /> 
                 {/* <Form.Control value={value} type="text" placeholder={placeholder} onBlur={handleBlur} onChange={handleChange}
                  isInvalid={!!errorsField && touched} /> 
                <Form.Control.Feedback type="invalid">
                     {errorsField}
                </Form.Control.Feedback>
             </div>
         </Form.Group>*/}
    </>
  );
};

export default InputText;
